import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { SearchInput } from '../../../subcomponents/form/input/search/search-input';
import { siteSearchKeys } from '../../../utils/filters/site-search-keys';
const b = bemClassBuilder('v-site-picker-search-form');
export const SitePickerSearchForm = observer(props => {
    const { sites, displayText, onResultsChanged, onSearchTermChanged } = props;
    const handleSubmit = event => {
        event.preventDefault();
    };
    return (_jsx("form", Object.assign({ className: b.block(), onSubmit: handleSubmit }, { children: _jsx(SearchInput, { searchValues: sites, searchKeys: siteSearchKeys, onResultsChanged: onResultsChanged, onSearchTermChanged: onSearchTermChanged, placeholder: displayText.searchInputPlaceholder }) })));
});
SitePickerSearchForm.displayName = 'SitePickerSearchForm';
